import { getParentAttachments } from './attachmentApi';

export const getCustomerPaymentAttachments = async (paymentId: number) =>
  getParentAttachments('payment', paymentId);

export const getBillPaymentAttachments = async (billPaymentId: number) =>
  getParentAttachments('bill_payment', billPaymentId);
